<formly-form [form]="form" [model]="formModel" [fields]="fields">
</formly-form>
